import { FolderAssetType } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { ROOT_FOLDER_ID } from '../../../../ads-studio-app-shared-components/src/model';
import { getFolderRepository } from './folder-repository';

// simplified version of asset library image repository
export const getBasicAssetsRepository = ({
  folderODataService,
  i18n,
  ianaTimeZone,
  timezoneUTCOffset,
  assetType,
  logger,
}) => {
  const folderRepository = getFolderRepository({
    logger,
    folderODataService,
    i18n,
    ianaTimeZone,
    timezoneUTCOffset,
  });

  const uploadImageToFolder = ({
    imageData,
    updateCurrentProgress,
    imageName,
    supportUpscale,
  }) => folderRepository.addFolderUploadAsset({
    folderId: ROOT_FOLDER_ID,
    asset: { data: imageData, name: imageName },
    folderAssetType: FolderAssetType.Image,
    inProgress: updateCurrentProgress,
    supportUpscale,
  });

  const loadAssets = ({
    windowIndex, windowSize, searchText, sortBy, minVideoDuration, maxVideoDuration, isSemanticSearch = false, isVideoDurationBoundaryIncluded = false, perfMarker,
  }) => {
    const top = windowSize;
    const skip = windowIndex * windowSize;
    if (perfMarker) {
      perfMarker.willInit();
    }
    const $ret = folderRepository.getFolderData({
      searchTerm: searchText,
      sortBy,
      minVideoDuration,
      maxVideoDuration,
      isVideoDurationBoundaryIncluded,
      skip,
      count: top,
      assetType,
      includeAssets: true,
      includeSubfolder: false,
      includeParentHierarchy: true,
      isGlobalSearch: true,
      withBIData: false,
      isSemanticSearch,
    }).then((response) => {
      if (perfMarker) {
        perfMarker.done();
      }
      const { folder } = response || {};
      const {
        assets,
        itemCount,
        // folderId,
        // folderName,
        // parentFolderId,
        // subfolders,
        // parentHierarchy,
      } = folder || {};

      if (isSemanticSearch && searchText && searchText.length > 0) {
        if (logger && logger.logTrace) {
          logger.logTrace('Embedded Search in Basic Assets Repository: load assets', {
            searchText,
            assets,
            totalItemCount: (itemCount && itemCount.TotalCount) || 0,
          });
        }
      }

      return {
        assets,
        totalItemCount: (itemCount && itemCount.TotalCount) || 0,
      };
    });
    return $ret;
  };

  const renameAsset = ({
    assetId,
    folderAssetType,
    name,
  }) => {
    const $ret = folderRepository.renameAsset({
      assetId,
      folderAssetType,
      name,
    });
    return $ret;
  };

  return {
    loadAssets,
    renameAsset,
    uploadImageToFolder,
    updateVideoStatusByIds: folderRepository.updateVideoStatusByIds,
  };
};
